import { useFeatureFlags } from 'utils/features';

export default function useJsaReportsEnabled() {
  return useFeatureFlags(['JSA_REPORTS', 'JOB_SAFETY_ANALYSIS']);
}
